import type { User } from '@supabase/supabase-js';

export const isPersonalLoginEnabled = (user: User | null | undefined): boolean =>
  user?.user_metadata?.personal_login_enabled !== false;

